<app-form-wrapper title="Preview">
  <div class="pv">
    <!-- The sender ID keeps its case, as handsets show it -->
    <p class="pv__from">
      <span class="pv__label">From</span>
      <span class="pv__sender" [class.is-empty]="!messagesService.messages.senderId">
        {{ messagesService.messages.senderId || "your sender ID" }}
      </span>
    </p>

    @if (messagesService.messages.body) {
      <bk-sms-bubble [text]="messagesService.messages.body" />
    } @else {
      <p class="pv__empty">Start typing the message and it appears here as a phone shows it.</p>
    }

    @if (messagesService.messages.body && units !== null) {
      <p class="pv__caption">
        Each send costs {{ parts.estimated ? "about " : "" }}<strong>{{ formatCount(units) }} SMS</strong>:
        {{ parts.parts }} {{ parts.parts === 1 ? "part" : "parts" }} ×
        {{ formatCount(audience.count) }} {{ audience.count === 1 ? "recipient" : "recipients" }}.
      </p>
    }

    @if (messagesService.messages.template) {
      <div class="pv__fact">
        <p class="pv__label">Template</p>
        <p class="pv__value">{{ messagesService.messages.template }}</p>
      </div>
    }

    <div class="pv__actions">
      <button
        type="button"
        class="bk-btn bk-btn--ghost"
        [disabled]="!messagesService.messages.body"
        (click)="handlePreviewMessage()"
      >
        <span class="bk-sym" aria-hidden="true">smartphone</span>
        Preview and send a test
      </button>
    </div>
  </div>
</app-form-wrapper>
